import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import cn from "classnames";
import { twMerge } from "tailwind-merge";
import { ReactPopover } from "../pages/album/wizard/Tracks/ReactPopover";

type Props = {
  hint: string;
  className?: string;
  iconClassName?: string;
};

export const LabelHint: React.FC<Props> = ({
  className,
  iconClassName,
  hint,
}) => {
  return (
    <div className={className}>
      <ReactPopover
        trigger={"hover"}
        content={
          <div
            className={
              "w-full text-muted font-normal flex justify-between text-xs whitespace-pre-line"
            }
            style={{ display: "inline-block" }}
          >
            <div>{hint}</div>
          </div>
        }
      >
        <FontAwesomeIcon
          icon={faCircleInfo}
          className={cn(twMerge("text-muted", iconClassName))}
        />
      </ReactPopover>
    </div>
  );
};
